import React, { useEffect, useRef } from 'react';
import {
  GoogleMap,
  withScriptjs,
  withGoogleMap,
  Marker,
  Polyline
} from 'react-google-maps';
import Card from '@mui/material/Card';
import iconMap from 'assets/images/driverImage.png';
import dropPin from 'assets/images/dropPin.png';
import originPin from 'assets/images/originPin.png';
import { brandColor } from 'config/brandColor';

const CommonMap = ({paths, stops, driverPathDetails, status})=> {
  const driverLat = driverPathDetails?.location?.lat;
  const driverLng = driverPathDetails?.location?.lng;
  const polyLines = driverPathDetails?.location?.polylines?.trip?.points;
    
  const driverData = [{lat:driverLat,lng:driverLng}]
  const icon1 = {
    url: iconMap,
    scaledSize: new window.google.maps.Size(40, 40),
    anchor: new window.google.maps.Point(20, 20),
    scale: 0.7,
  };
  const mapRef = useRef(null);

  // Fit bounds function
  const fitBounds = () => {
    const bounds = new window.google.maps.LatLngBounds();
    let boundPath = stops
    if(driverLat && driverLng){
      boundPath = [...boundPath, {lat:driverLat,lng:driverLng}]
    }else{
      boundPath = boundPath
    }
    boundPath.map(item => {
      bounds.extend(item);
      return item
    });
    mapRef.current.fitBounds(bounds);
  };

  // Fit bounds on mount, and when the markers change
  useEffect(() => {
    fitBounds();
  }, []);
  
    return(
      <Card variant="outlined">
        <div className='gMapCont'>
          <GoogleMap
            ref={mapRef}
            defaultZoom={10}
            defaultCenter={{ lat: paths?.length > 0 && paths[0]?.lat, lng: paths?.length > 0 && paths[0]?.lng }}
          >
            <Polyline
                path={ polyLines ? polyLines : paths}
                options={{
                strokeColor: brandColor("primary", "#0F538D"),
                strokeWeight: 6,
                // strokeOpacity: 0.6,
                defaultVisible: true,
                }}
            />
               {status?.toLocaleLowerCase() === 'ongoing' && <Marker
                    icon={dropPin}
                    position={polyLines ? polyLines[polyLines?.length-1] :{lat:stops[1]?.lat,lng:stops[1]?.lng}}
                    // title={stops[1].id}
                    // label={``}
                />}
                {status?.toLocaleLowerCase() === 'dispatched' && <Marker
                    icon={dropPin}
                    position={{lat:stops[1]?.lat,lng:stops[1]?.lng}}
                    // title={stops[1].id}
                    // label={``}
                />}
                <>
                {/* <Polyline
                  path={ driverData[0] ? driverData[0] : stops[0]}
                  options={{ strokeColor: "orange" }}
                /> */}
                <Marker
                  icon={icon1}
                  position={(driverData?.length > 0 && driverData[0]?.lat && driverData[0]?.lat !== null)  ? driverData[0] : {}}                   
                />
                {status?.toLocaleLowerCase() === 'dispatched' && <Marker
                  icon={originPin}
                  position={stops[0]}                   
                />}
                </>
          </GoogleMap>
        </div>
      </Card>  
    )
};

export default withScriptjs(
  withGoogleMap(
    CommonMap
  )
)